import { SettingsIcon } from 'components/common/Icon';
import { useCurrentCompany, useNavigate } from 'hooks/api';
import { BusinessStatusLabel } from 'models/business';
import { Routes } from 'fnRoutes';
import { isBusinessFullSuite } from 'components/ProgressTracker/util';
import { useTranslation } from 'react-i18next';
import { NavMenuItem } from './NavMenuItem';

export const PreferencesMenu = () => {
  const { t } = useTranslation();
  const { currentCompany } = useCurrentCompany();
  const navigate = useNavigate();
  const isFullSuite = isBusinessFullSuite(currentCompany);
  const customerStatus = currentCompany?.status ?? '';

  const goToAccountSetting = () => {
    navigate(Routes.ACCOUNT_SETTING);
  };

  const goToMySubscription = () => {
    navigate(Routes.MY_SUBSCRIPTION);
  };

  const goToMyDomains = () => {
    navigate(Routes.SQUARESPACE_DOMAIN_MANAGEMENT);
  };

  const goToMySetup = () => {
    navigate(Routes.SETUP_PAGE);
  };

  const menuList = [
    {
      name: t('topNavBar.preferences.accountSettings'),
      disabledForStatus: [],
      clickHandler: goToAccountSetting,
      disabled: true,
      hidden: true,
    },
    {
      name: t('topNavBar.preferences.mySetup'),
      disabledForStatus: ['NEW'],
      clickHandler: goToMySetup,
      hidden: !isFullSuite,
    },
    {
      name: t('topNavBar.preferences.mySubscription'),
      disabledForStatus: ['NEW'],
      clickHandler: goToMySubscription,
    },
    {
      name: t('topNavBar.preferences.myDomains'),
      disabledForStatus: ['NEW'],
      clickHandler: goToMyDomains,
      hidden: customerStatus !== BusinessStatusLabel.ACTIVE,
    },
    {
      name: t('topNavBar.preferences.connections'),
      disabled: true,
      hidden: true,
    },
  ];

  return (
    <NavMenuItem
      tooltipTitle={t('topNavBar.preferences.tooltipTitle')}
      menuList={menuList}
      mainIcon={SettingsIcon}
      menuName={t('topNavBar.preferences.name')}
      business={currentCompany}
    />
  );
};
